type UseClass = (string | undefined)[]

export const useClass = (...props: UseClass) => {
  return [...props].join(' ')
}
